import 'core-js/es/object/has-own';
import 'core-js/es/array/at';
import 'core-js/es/math/sign';
import 'core-js/es/object/group-by';

import { ResizeObserver as Polyfill } from '@juggle/resize-observer';

window.ResizeObserver = window.ResizeObserver || Polyfill;
